import gql from 'graphql-tag';

/** Signed one-hour pass for the preview window (one page, project or folder), instead of the login token. */
export default gql`
  mutation PreviewPass($page_id: Int, $project_id: Int, $folder_id: Int) {
    previewPass(page_id: $page_id, project_id: $project_id, folder_id: $folder_id) { pass }
  }
`;
